const RECOIL_KEYS = {
  USER_DETAILS: "userDetails",
  SEARCH_VALUE: "searchValue",
  RECIPIENT_DETAILS: "recipientDetails",
  USER_TRANSACTION_DETAILS: "userTransactionDetails",
  USER_TRANSACTION_REMARKS: "userTransactionRemarks",
  KYC_DETAILS: "kycDetails",
  CONFIRMED_PURPOSE: "confirmedPurpose",
  ADDITIONAL_DATA: "additionalDocData",
  USER_ADDITIONAL_DOC: "userAdditionalDocs",
  OFFLINE_FLYWIRE: "offlineFlywire",
  OFFLINE_WESTERN_UNION: "offlineWesternUnion",
  OFFLINE_SBM: "offlineSbm",
  MASTER_VENDOR: "isMasterVendor",
  LOAN_MODAL: "isLoanModal",
  ESIGN_STATUS: "esignStatus",
  VENDOR_CODES: "vendorCodes",
  IS_RESIGNED: "isResigned",
  DECLARATION_DETAILS: "declarationDetails",
  TRANSACTION_ID: "transactionId",
  HISTORY_PAGE_SELECTED_TRANSACTION: "historyPageSelectedTransaction",
  HISTORY_PAGE_SELECTED_TRANSACTION_ID: "historyPageSelectedTransactionId",
  HISTORY_PAGE_SELECTED_TRANSACTION_REJECTION_STATUS:
    "historyPageSelectedTransactionRejectionStatus",
  Bene: "bene",
  ROUND_OFF: "roundOff",
  PAN_DECLARATION: "panDeclaration",
  REMITTER_ID: "remitterID",
  HISTORY_PAGE_ESIGN_MODAL: "historyPageEsignModal",
  SELECTED_PURPOSE_CODE: "selectedPurposeCode",
  SELECTED_VENDOR: "selectedVendor",
  CURRENT_ROLE: "currentRole",
  START_TIMER: "startTimer",
  TIMER_STATE: "timerState",
  TRIGGER_TRANSACTION_SUMMARY: "triggerTransactionSummary",
  SHOW_TIMER_TEXT: "showTimerText",
};

export default RECOIL_KEYS;
